/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:51:23
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-18 14:27:46
 * @FilePath: \monitor\src\language\project\index.js
 * @Description: 
 */
import Project from "./project";
import Zone from "./zone";
import Datalogger from "./datalogger";
import User from "./user";
const CN = {
  Project: Project.CN,
  Zone: Zone.CN,
  Datalogger: Datalogger.CN,
  User: User.CN,
};
const EN = {
  Project: Project.EN,
  Zone: Zone.EN,
  Datalogger: Datalogger.EN,
  User: User.EN,
};
export default {
  CN,
  EN
};



// WEBPACK FOOTER //
// ./src/language/project/index.js